import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./transaction_user_action.js";
//#region src/transaction_user_action_helper.ts
var transaction_user_action_helper_exports = /* @__PURE__ */ __exportAll({ stringFromEnum: () => stringFromEnum });
function stringFromEnum(userAction) {
	switch (userAction) {
		case 0: return "none";
		case 1: return "cancelled";
		case 2: return "abandoned";
	}
}
//#endregion
export { stringFromEnum, transaction_user_action_helper_exports };

//# sourceMappingURL=transaction_user_action_helper.js.map